import { normalizeSportValue } from '../constants/sports'

// Indicador de participacion del jugador (spec §4.7): en que deportes participa
// este ciclo y a cuales jugaba antes. Es presentacion: no guarda nada, se calcula
// desde las inscripciones que ya existen.

// "Ciclo pasado" = la temporada CERRADA mas reciente DE CADA DEPORTE (decision
// 2026-07-16). Con un club multideporte los calendarios no coinciden (flag puede
// cerrar en diciembre y tackle en marzo), asi que una sola "ultima cerrada" del
// club dejaria fuera deportes en los que el jugador si jugo.
export const temporadaAnteriorPorDeporte = (temporadas = []) => {
  const porDeporte = new Map()
  for (const t of temporadas) {
    if (t?.estado !== 'cerrada') continue
    const deporte = normalizeSportValue(t.deporte_id)
    const previa = porDeporte.get(deporte)
    if (!previa || String(t.fecha_inicio || '') > String(previa.fecha_inicio || '')) {
      porDeporte.set(deporte, t)
    }
  }
  return porDeporte
}

// Devuelve { [jugadorId]: { actuales: [{deporteId, estatus}], anteriores: [deporteId] } }
//
// - actuales: inscripciones en temporadas ABIERTAS, excluyendo la que se esta
//   gestionando (su estado ya lo pinta la propia fila) y las de estatus 'baja'.
// - anteriores: deportes cuya temporada cerrada mas reciente lo tuvo inscrito
//   (sin contar 'baja'), omitiendo los que ya aparecen en actuales: si sigue
//   jugando flag, decir "Antes: Flag" es ruido.
export const buildParticipacionByJugador = ({
  inscripciones = [],
  temporadas = [],
  excluirTemporadaId = null,
} = {}) => {
  const temporadaById = new Map((temporadas || []).map((t) => [t.id, t]))
  const anteriorPorDeporte = temporadaAnteriorPorDeporte(temporadas)
  const anterioresIds = new Set([...anteriorPorDeporte.values()].map((t) => t.id))

  const out = {}
  const ensure = (id) => {
    if (!out[id]) out[id] = { actuales: [], anteriores: [] }
    return out[id]
  }

  for (const i of inscripciones) {
    const t = temporadaById.get(i.temporada_id)
    if (!t || i.estatus === 'baja') continue
    const deporteId = normalizeSportValue(t.deporte_id)

    if (t.estado === 'abierta' && t.id !== excluirTemporadaId) {
      const p = ensure(i.jugador_id)
      if (!p.actuales.some((a) => a.deporteId === deporteId)) {
        p.actuales.push({ deporteId, estatus: i.estatus })
      }
    } else if (anterioresIds.has(t.id)) {
      const p = ensure(i.jugador_id)
      if (!p.anteriores.includes(deporteId)) p.anteriores.push(deporteId)
    }
  }

  // Un deporte que sigue vivo no se repite como "antes".
  for (const p of Object.values(out)) {
    const vivos = new Set(p.actuales.map((a) => a.deporteId))
    p.anteriores = p.anteriores.filter((d) => !vivos.has(d))
  }
  return out
}
